import { render, staticRenderFns } from "./SharpImpactZone.vue?vue&type=template&id=487b142f&scoped=true"
import script from "./SharpImpactZone.vue?vue&type=script&lang=js"
export * from "./SharpImpactZone.vue?vue&type=script&lang=js"
import style0 from "./SharpImpactZone.vue?vue&type=style&index=0&id=487b142f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b142f",
  null
  
)

export default component.exports